.root {
  position: relative;
  font-size: 14px;
  font-weight: var(--font-weight-light);

  /*
    The nested span here is solely for not round off the
    active click area, which makes the calendar feel a little wonky and unresponsive.
  */
  span {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    content: "";
    border-radius: 9999px;
  }

  &[aria-disabled="true"] {
    color: var(--calendar-day-disabled-color);
  }
}

.selected span {
  color: var(--calendar-day-active-color);
  background-color: var(--calendar-day-active-background);
}

.blur {
  color: var(--calendar-day-blurred-color);
}

.clickable {
  cursor: pointer;

  &:not(.selected):not(.disabled):hover {
    color: var(--calendar-day-color);

    span {
      background-color: var(--calendar-day-color-background);
    }
  }
}

.today span {
  text-decoration: underline;
}
